import { FC, useMemo } from 'react';
import { times } from 'lodash';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { SkeletonTableProps } from './types';

const bodyTemplate = () => <Skeleton />;

const SkeletonTable: FC<SkeletonTableProps> = ({ columns, quantity = 5 }) => {
  const items = useMemo(() => times(quantity, (i) => ({ i })), [quantity]);

  return (
    <DataTable value={items} className="p-datatable-striped data-table">
      {columns.map(({ header, className }) => (
        <Column
          key={header}
          header={header}
          className={`col ${className}`}
          body={bodyTemplate}
        />
      ))}
    </DataTable>
  );
};

export default SkeletonTable;
